import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { getAGraphBaseUrl, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { conditionalParam } from './AGraphUtils';
import { AW_PORTFOLIO_MANAGEMENT_API_URL } from './Constants';
interface Settings extends AGraphApiSettings {
  getConfigurationDirectoryFn?: () => string | undefined;
  getPkgFn?: () => string | undefined;
}

export const awPortfolioManagementSettings: Settings = {};
export const awPortfolioManagementApi = axios.create();

awPortfolioManagementApi.interceptors.request.use((config) => {
  const { getPkgFn, getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awPortfolioManagementSettings;
  const configurationDirectory = getConfigurationDirectoryFn?.();
  const baseURL = getAGraphBaseUrl(AW_PORTFOLIO_MANAGEMENT_API_URL);
  const pkg = config.params?.pkg ?? getPkgFn?.();

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      pkg: conditionalParam(config.url, 'pkg', pkg),
      configurationDirectory: conditionalParam(config.url, 'configurationDirectory', configurationDirectory),
    },
  };
  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());

  return updatedConfig;
});
